import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
  AMEDAS_TYPE_AIR_TEMP,
  AMEDAS_TYPE_PRECIPITATION,
  AMEDAS_TYPE_SNOW_DEPTH,
  AMEDAS_TYPE_SUNSHINE, AMEDAS_TYPE_WIND_DIR
} from "../layers/Amedas";
import { LegendBoxContentsName, LegendBoxList, LegendCssSquareIconListItem, LegendListDivider } from "../../legend/LegendBoxComponents";
import { useRecoilValue } from "recoil";
import { amedasElementState } from "../../../store/AmedasElementState";
import { memo } from "react";

function LegendAmedas() {
  const dataType = useRecoilValue(amedasElementState);

  const getLegendComponent = (type) => {
    switch (type) {
      case AMEDAS_TYPE_SUNSHINE:
        return <Sunshine dataType={dataType}/>;
      case AMEDAS_TYPE_AIR_TEMP:
        return <Temperature dataType={dataType}/>;
      case AMEDAS_TYPE_PRECIPITATION:
        return <Precipitation dataType={dataType}/>;
      case AMEDAS_TYPE_SNOW_DEPTH:
       return <Snow dataType={dataType}/>
      default:
        return null;
    }
  }
  return (
    <Box sx={{display:'flex', columnGap:10, minWidth: 77}}>
      {
        getLegendComponent(dataType)
      }
      <Wind/>
    </Box>
  )
}

function LegendBoxAmedasName(props) {
  const { dataType } = props;
  let name = "";
  let unit = ""
  const {t} = useTranslation();
  switch(dataType) {
    case AMEDAS_TYPE_SUNSHINE:
      name = "Sunshine duration";
      unit = "(min/h)";
      break;
    case AMEDAS_TYPE_AIR_TEMP:
      name = "Temperature";
      unit = "(°C)";
      break;
    case AMEDAS_TYPE_PRECIPITATION:
      name = "Precipitation";
      unit = "(mm/h)";
      break;
    case AMEDAS_TYPE_SNOW_DEPTH:
      name = "Snow depth";
      unit = "(cm)";
      break;
    case AMEDAS_TYPE_WIND_DIR:
      name = "Wind speed";
      unit = "(kt)";
      break;
    default:
      break;
  }
  return (
    <Box>
      <LegendBoxContentsName>{t(name)} {unit}</LegendBoxContentsName>
    </Box>
  )
}

function Sunshine(props) {
  const { dataType } = props;
  return (
    <div>
      <LegendBoxAmedasName {...props}/>
      <Box sx={{display: dataType !== AMEDAS_TYPE_SUNSHINE ? "none" : "flex"}}>
        <LegendBoxList>
          <LegendCssSquareIconListItem background={'rgb(180, 0, 104)'} text={<>60</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 40, 0)'} text={<>48</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 153, 0)'} text={<>36</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(250, 245, 0)'} text={<>24</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(185, 235, 255)'} text={<>12</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 65, 255)'} text={<></>}></LegendCssSquareIconListItem>
        </LegendBoxList>
      </Box>
    </div>
  )
}

function Temperature(props) {
  const { dataType } = props;
  return (
    <div>
      <LegendBoxAmedasName {...props}/>
      <Box sx={{display: dataType !== AMEDAS_TYPE_AIR_TEMP ? "none" : "flex"}}>
        <LegendBoxList>
          <LegendCssSquareIconListItem background={'rgb(180, 0, 104)'} text={<>35</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 40, 0)'} text={<>30</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 153, 0)'} text={<>25</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(250, 245, 0)'} text={<>20</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 255, 150)'} text={<>15</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 255, 240)'} text={<>10</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(185, 235, 255)'} text={<>5</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 150, 255)'} text={<>0</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 65, 255)'} text={<>-5</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 32, 128)'} text={<></>}></LegendCssSquareIconListItem>
        </LegendBoxList>
      </Box>
    </div>
  )
}

function Precipitation(props) {
  const { dataType } = props;
  return (
    <div>
      <LegendBoxAmedasName {...props}/>
      <Box sx={{display: dataType !== AMEDAS_TYPE_PRECIPITATION ? "none" : "flex"}}>
        <LegendBoxList>
          <LegendCssSquareIconListItem background={'rgb(180, 0, 104)'} text={<>80</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 40, 0)'} text={<>50</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 153, 0)'} text={<>30</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(250, 245, 0)'} text={<>20</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 65, 255)'} text={<>10</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(33, 140, 255)'} text={<>5</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(160, 210, 255)'} text={<>1</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(242, 242, 255)'} text={<></>}></LegendCssSquareIconListItem>
        </LegendBoxList>
      </Box>
    </div>
  )
}

function Snow(props) {
  const { dataType } = props;
  return (
    <div>
      <LegendBoxAmedasName {...props}/>
      <Box sx={{display: dataType !== AMEDAS_TYPE_SNOW_DEPTH ? "none" : "flex"}}>
        <LegendBoxList>
          <LegendCssSquareIconListItem background={'rgb(180, 0, 104)'} text={<>200</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 40, 0)'} text={<>150</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 153, 0)'} text={<>100</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(250, 245, 0)'} text={<>50</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 65, 255)'} text={<>20</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(33, 140, 255)'} text={<>5</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(160, 210, 255)'} text={<>1</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(242, 242, 255)'} text={<></>}></LegendCssSquareIconListItem>
        </LegendBoxList>
      </Box>
    </div>
  )
}
function Wind() {
  return (
    <div>
      <LegendBoxAmedasName dataType={AMEDAS_TYPE_WIND_DIR}/>
      <Box sx={{display:  "flex"}}>
        <LegendBoxList>
          <LegendCssSquareIconListItem background={'rgb(251, 0, 6)'} text={<>48</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(253, 135, 9)'} text={<>38</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(255, 255, 11)'} text={<>28</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(34, 255, 8)'} text={<>18</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 0, 255)'} text={<>8</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgb(0, 0, 0)'} text={<>0</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
        </LegendBoxList>
      </Box>
    </div>
  )
}
export default memo(LegendAmedas);